module.exports = (s) => {
  return [
    /** field指标 */
    {
      name: '消耗',
      value: 'stat_cost',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '展示数',
      value: 'show_cnt',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '平均千次展现费用',
      value: 'cpm_platform',
    },
    {
      name: '点击数',
      value: 'click_cnt',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '点击率',
      value: 'ctr',
    },
    {
      name: '平均点击单价',
      value: 'cpc_platform',
    },
    {
      name: '转化数',
      value: 'convert_cnt',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '平均转化成本',
      value: 'conversion_cost',
    },
    {
      name: '转化率',
      value: 'conversion_rate',
    },
    {
      name: '深度转化数',
      value: 'deep_convert_cnt',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '深度转化成本',
      value: 'deep_convert_cost',
    },
    {
      name: '深度转化率',
      value: 'deep_convert_rate',
    },
    {
      name: '安卓安装完成数',
      value: 'install_finish_cnt',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '安卓安装完成成本',
      value: 'install_finish_cost',
    },
    {
      name: '安卓安装完成率',
      value: 'install_finish_rate',
    },
    {
      name: '激活数',
      value: 'active',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '激活成本',
      value: 'active_cost',
    },
    {
      name: '激活率',
      value: 'active_rate',
    },
    {
      name: '注册数',
      value: 'active_register',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '注册成本',
      value: 'active_register_cost',
    },
    {
      name: '注册率',
      value: 'active_register_rate',
    },
    {
      name: '关键行为数',
      value: 'game_addiction',
    },
    {
      name: '关键行为成本',
      value: 'game_addiction_cost',
    },
    {
      name: '关键行为率',
      value: 'game_addiction_rate',
    },
    {
      name: '首次付费数',
      value: 'active_pay',
    },
    {
      name: '首次付费成本',
      value: 'active_pay_cost',
    },
    {
      name: '首次付费率',
      value: 'active_pay_rate',
    },
    {
      name: '付费次数',
      value: 'game_pay_count',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '付费成本',
      value: 'game_pay_cost',
    },
    {
      name: '7日付费次数',
      value: 'attribution_game_pay_7d_count',
    },
    {
      name: '7日付费成本',
      value: 'attribution_game_pay_7d_cost',
    },
    {
      name: '7日人均付费次数',
      value: 'attribution_active_pay_7d_per_count',
    },
    {
      name: '当日付费金额',
      value: 'attribution_game_in_app_ltv_1day',
    },
    {
      name: '激活后一日付费金额',
      value: 'attribution_game_in_app_ltv_2days',
    },
    {
      name: '激活后3日付费金额',
      value: 'attribution_game_in_app_ltv_4days',
    },
    {
      name: '激活后7日付费金额',
      value: 'attribution_game_in_app_ltv_8days',
    },
    {
      name: '当日付费ROI',
      value: 'attribution_game_in_app_roi_1day',
    },
    {
      name: '激活后一日付费ROI',
      value: 'attribution_game_in_app_roi_2days',
    },
    {
      name: '激活后3日付费ROI',
      value: 'attribution_game_in_app_roi_4days',
    },
    {
      name: '激活后7日付费ROI',
      value: 'attribution_game_in_app_roi_8days',
    },
    {
      name: '次留数',
      value: 'attribution_next_day_open_cnt',
    },
    {
      name: '次留成本',
      value: 'attribution_next_day_open_cost',
    },
    {
      name: '次留率',
      value: 'attribution_next_day_open_rate',
    },
  ];
};

